export const responsiveImage = (largeImg, smallImage) => {
	if (window.innerWidth < 1200) {
		return smallImage;
	}
	return largeImg;
};



// WEBPACK FOOTER //
// ./src/util/responsiveImage.js